import type { FunctionComponent } from "react";

export const ServiceRowSkeleton: FunctionComponent = () => (
  <div
    data-testid="service-row-skeleton"
    className="animate-pulse flex items-center gap-3 w-full max-w-[300px] md:w-[300px] border-[0.5px] border-neutral-300 rounded py-2.5 px-3"
  >
    <div className="w-[52px] h-7 bg-black-300 rounded-md shrink-0" />
    <div className="w-full min-w-0">
      <div className="w-1/2 h-4 bg-black-300 rounded-md mb-1.5" />
      <div className="w-3/4 h-3 bg-black-300 rounded-md" />
    </div>
  </div>
);
